import React from 'react';

const PlanInfoBox = ({ icon: Icon, title, subtitle }) => (
  <div className="flex items-start w-full gap-v3-sm">
    <div className="flex w-11 h-11 justify-center items-center shrink-0 rounded-v3-xs border border-v3-neutral-border bg-white shadow-v3-light">
      {typeof Icon === 'function' ? <Icon /> : Icon}
    </div>
    <div className="flex flex-col items-start flex-1 min-w-0 gap-v3-xxs">
      <span className="font-inter-variable text-v3-h8 font-semibold text-v3-black-max">
        {title}
      </span>
      <span className="font-inter-variable text-xs font-medium leading-4 text-v3-black-secondary min-h-8">
        {subtitle}
      </span>
    </div>
  </div>
);

export default PlanInfoBox;
